import { render, staticRenderFns } from "./NsCurrency.vue?vue&type=template&id=76188aff&scoped=true&"
import script from "./NsCurrency.vue?vue&type=script&lang=js&"
export * from "./NsCurrency.vue?vue&type=script&lang=js&"
import style0 from "./NsCurrency.vue?vue&type=style&index=0&id=76188aff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76188aff",
  null
  
)

export default component.exports